export default "/images/7f7a988690166e5f8059d7b380806fbe.avif";